var map = {
	"./basme/0.jpg": "78d5",
	"./cacealma/0.jpg": "8ddf",
	"./discursuri/0.jpg": "fd6e",
	"./gewalt/0.jpg": "2887",
	"./jurnal-tetelu/0.jpg": "79f7",
	"./la-inceput/0.jpg": "e35c",
	"./nichita/0.jpg": "5dbd",
	"./oaianeagra/0.jpg": "6daf",
	"./peei/0.jpg": "ff5a",
	"./scrisoare-tata/0.jpg": "c15e",
	"./scrisori-front/0.jpg": "27ff",
	"./urletul/0.jpg": "7e49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b95";